import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import { styles } from "./AccountTier.styles";
import { Button } from "@mui/material";
import { accountTiers, userProfile } from "services/dashboard";
import { useQuery } from "@tanstack/react-query";
import { kFormatter } from "utils/formatCurrency";
import { useNavigate } from "react-router-dom/dist";

const AccountTier = ({ data }) => {
  /*   const getAccountBalance = (account_no) => {
    return data?.account_balances?.find(
      (item) => item.account_no === account_no
    );
  }; */

  const { data: profile, isLoading: is } = useQuery({
    queryKey: ["userProfile"],
    queryFn: userProfile,
  });

  const { data: accountTierList, isLoading } = useQuery({
    queryKey: ["accountTiers"],
    queryFn: accountTiers,
  });

  const limits = profile?.customer?.limits;

  console.log(limits);

  const navigate = useNavigate();

  return (
    <Box sx={styles.container}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography sx={styles.header}>Tier Levels</Typography>
        </Box>

        {/* <Button sx={styles.addNewBtn}>+ Add new</Button> */}
      </Stack>

      {isLoading || is ? (
        <Box sx={styles.loadingAnimation}>
          <Skeleton
            sx={{
              width: "100%",
              height: { xs: 190, sm: 250 },
              borderRadius: { xs: "15px", sm: "20px" },
              transform: "none",
            }}
          />
        </Box>
      ) : (
        <Box mt={2} sx={styles.cardContainer}>
          {accountTierList?.map((item) => {
            return (
              <div
                style={limits?.tier === item?.tier ? styles.card2 : styles.card}
              >
                <div
                  style={limits?.tier === item?.tier ? styles.top2 : styles.top}
                >
                  <svg
                    width="20"
                    height="27"
                    viewBox="0 0 20 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      marginRight: "10px",
                    }}
                  >
                    <path
                      d="M15.188 0.434563V10.1812C15.188 10.2959 15.1425 10.4058 15.0614 10.4869C14.9804 10.5679 14.8704 10.6135 14.7558 10.6135H6.01621C5.90158 10.6135 5.79164 10.5679 5.71058 10.4869C5.62952 10.4058 5.58398 10.2959 5.58398 10.1812V0.434563C5.58442 0.353684 5.60727 0.274509 5.65 0.205837C5.69273 0.137165 5.75367 0.0816843 5.82603 0.045561C5.89951 0.0100795 5.98153 -0.00387907 6.0626 0.00529947C6.14368 0.014478 6.2205 0.0464187 6.28419 0.0974279L10.3817 3.33479L14.3236 0.222773L14.4878 0.0931057C14.5517 0.0426391 14.6285 0.011231 14.7094 0.00249619C14.7903 -0.00623858 14.8721 0.00805505 14.9452 0.043732C15.0184 0.0794089 15.08 0.135019 15.123 0.204161C15.1659 0.273304 15.1885 0.353169 15.188 0.434563Z"
                      fill="#E1E1E1"
                    />
                    <path
                      d="M14.3236 0.223147V9.31715C14.3236 9.43179 14.278 9.54173 14.197 9.62278C14.1159 9.70384 14.006 9.74938 13.8913 9.74938H5.58398V0.434937C5.58442 0.354058 5.60727 0.274883 5.65 0.206211C5.69273 0.137538 5.75367 0.0820581 5.82603 0.0459348C5.89951 0.0104533 5.98153 -0.00350526 6.0626 0.00567328C6.14368 0.0148518 6.2205 0.0467925 6.28419 0.0978017L10.3817 3.33516L14.3236 0.223147Z"
                      fill="#ca2d2d"
                    />
                    <path
                      d="M19.1427 17.5656C19.0687 17.4524 19.0293 17.3201 19.0293 17.1848C19.0293 17.0495 19.0687 16.9172 19.1427 16.804L19.7456 15.8803C19.8658 15.6966 19.9459 15.4895 19.9806 15.2727C20.0154 15.0559 20.004 14.8342 19.9472 14.6221C19.8904 14.41 19.7895 14.2122 19.6511 14.0417C19.5127 13.8713 19.3399 13.7319 19.144 13.6328L18.1594 13.134C18.0388 13.0729 17.9386 12.9781 17.871 12.861C17.8034 12.744 17.7713 12.6098 17.7786 12.4748L17.8391 11.3731C17.8508 11.1543 17.8164 10.9355 17.738 10.731C17.6596 10.5264 17.539 10.3406 17.3841 10.1857C17.2292 10.0308 17.0434 9.91019 16.8388 9.83179C16.6342 9.75339 16.4154 9.71893 16.1967 9.73065L15.0953 9.79073C14.9604 9.79794 14.8262 9.76584 14.7092 9.69832C14.5921 9.63081 14.4971 9.53078 14.4358 9.41037L13.937 8.4262C13.8379 8.23022 13.6987 8.05736 13.5282 7.91893C13.3578 7.78049 13.16 7.6796 12.9479 7.62285C12.7358 7.56609 12.5141 7.55476 12.2973 7.58959C12.0805 7.62443 11.8735 7.70463 11.6898 7.82497L10.7653 8.42749C10.6521 8.50131 10.5199 8.54061 10.3847 8.54061C10.2496 8.54061 10.1174 8.50131 10.0042 8.42749L9.08051 7.82497C8.89681 7.70463 8.68977 7.62441 8.47295 7.58958C8.25612 7.55474 8.03438 7.56607 7.82223 7.62282C7.61008 7.67957 7.4123 7.78047 7.24183 7.9189C7.07135 8.05734 6.93201 8.23021 6.83294 8.4262L6.33415 9.4108C6.27207 9.53062 6.17695 9.63013 6.06005 9.69755C5.94315 9.76496 5.80937 9.79745 5.67457 9.79116L4.57327 9.73108C4.35449 9.71937 4.1357 9.75383 3.93113 9.83222C3.72655 9.91062 3.54076 10.0312 3.38584 10.1861C3.23093 10.341 3.11035 10.5268 3.03195 10.7314C2.95356 10.936 2.9191 11.1548 2.93081 11.3735L2.99132 12.4748C2.99867 12.6099 2.96654 12.7442 2.89884 12.8613C2.83115 12.9785 2.73082 13.0734 2.6101 13.1344L1.62636 13.6332C1.43035 13.7323 1.25745 13.8716 1.11896 14.042C0.980474 14.2125 0.879516 14.4102 0.822688 14.6223C0.76586 14.8345 0.754442 15.0562 0.789178 15.2731C0.823914 15.4899 0.904024 15.697 1.02427 15.8808L1.62722 16.8044C1.70124 16.9176 1.74065 17.05 1.74065 17.1852C1.74065 17.3205 1.70124 17.4528 1.62722 17.566L1.02427 18.4897C0.904145 18.6735 0.824124 18.8805 0.78943 19.0973C0.754737 19.3141 0.76615 19.5358 0.822926 19.7479C0.879701 19.96 0.980563 20.1577 1.11893 20.3282C1.25729 20.4987 1.43005 20.6381 1.62593 20.7373L2.61053 21.236C2.7311 21.2971 2.83129 21.392 2.8989 21.509C2.96651 21.626 2.99863 21.7602 2.99132 21.8952L2.93081 22.9969C2.9191 23.2157 2.95356 23.4345 3.03195 23.6391C3.11035 23.8436 3.23093 24.0294 3.38584 24.1843C3.54076 24.3393 3.72655 24.4598 3.93113 24.5382C4.1357 24.6166 4.35449 24.6511 4.57327 24.6394L5.67457 24.5793C5.80972 24.5712 5.94426 24.603 6.0615 24.6707C6.17875 24.7384 6.27355 24.839 6.33415 24.9601L6.83294 25.9443C6.93203 26.1402 7.07136 26.3131 7.24182 26.4515C7.41229 26.59 7.61005 26.6909 7.82218 26.7477C8.03431 26.8045 8.25604 26.8158 8.47287 26.7811C8.68971 26.7463 8.89676 26.6662 9.08051 26.5459L10.005 25.943C10.1182 25.8689 10.2504 25.8295 10.3856 25.8295C10.5208 25.8295 10.6531 25.8689 10.7662 25.943L11.6898 26.5459C11.8736 26.6661 12.0807 26.7462 12.2975 26.7809C12.5143 26.8157 12.736 26.8043 12.9481 26.7475C13.1602 26.6907 13.358 26.5898 13.5284 26.4514C13.6989 26.313 13.8383 26.1402 13.9374 25.9443L14.4362 24.9601C14.4965 24.8388 14.5913 24.738 14.7086 24.6703C14.8259 24.6025 14.9606 24.5709 15.0958 24.5793L16.1949 24.6385C16.4137 24.6502 16.6325 24.6158 16.8371 24.5374C17.0416 24.459 17.2274 24.3384 17.3823 24.1835C17.5373 24.0286 17.6578 23.8428 17.7362 23.6382C17.8146 23.4336 17.8491 23.2148 17.8374 22.9961L17.7769 21.8943C17.7695 21.7593 17.8017 21.6251 17.8694 21.508C17.9371 21.391 18.0374 21.2962 18.1581 21.2352L19.1418 20.7364C19.3378 20.6373 19.5106 20.498 19.6491 20.3275C19.7875 20.1571 19.8885 19.9593 19.9453 19.7472C20.0021 19.5351 20.0135 19.3134 19.9788 19.0965C19.9442 18.8797 19.8641 18.6726 19.7439 18.4888L19.1427 17.5656Z"
                      fill="#ca2d2d"
                    />
                    <path
                      d="M16.9303 17.1883C16.9306 18.5075 16.5318 19.796 15.7864 20.8844C15.0409 21.9728 13.9836 22.8103 12.7534 23.2867C11.5233 23.7632 10.1777 23.8564 8.8936 23.554C7.60949 23.2517 6.44687 22.5679 5.55849 21.5927C5.54985 21.5884 5.54553 21.5884 5.54553 21.5797C4.41453 20.3366 3.80575 18.7057 3.84559 17.0256C3.88543 15.3454 4.57082 13.7452 5.75947 12.5571C6.94811 11.369 8.54867 10.6844 10.2288 10.6453C11.909 10.6063 13.5396 11.2158 14.7822 12.3474C14.7865 12.3474 14.7908 12.3517 14.7951 12.3604C15.4684 12.9714 16.0062 13.7167 16.3739 14.5482C16.7417 15.3798 16.9312 16.2791 16.9303 17.1883Z"
                      fill="#FFF176"
                    />
                    <path
                      d="M16.4981 16.7561C16.4982 18.0232 16.1302 19.263 15.4388 20.3248C14.7473 21.3866 13.7623 22.2246 12.6034 22.737C11.4445 23.2494 10.1617 23.414 8.91104 23.2108C7.66035 23.0077 6.49562 22.4455 5.55849 21.5927C5.54985 21.5884 5.54553 21.5884 5.54553 21.5797C4.41453 20.3366 3.80575 18.7057 3.84559 17.0256C3.88543 15.3454 4.57082 13.7452 5.75947 12.5571C6.94811 11.369 8.54867 10.6844 10.2288 10.6453C11.909 10.6063 13.5396 11.2158 14.7822 12.3474C14.7865 12.3474 14.7908 12.3517 14.7951 12.3604C15.8936 13.5604 16.5014 15.1292 16.4981 16.7561Z"
                      fill="white"
                    />
                    <path
                      d="M9.84263 20.1324C9.45669 20.1324 9.08683 20.0735 8.73305 19.9555C8.38463 19.8376 8.0925 19.6714 7.85664 19.457L8.12198 18.8781C8.38463 19.0925 8.65533 19.248 8.93406 19.3445C9.21279 19.4409 9.50761 19.4892 9.81851 19.4892C10.2312 19.4892 10.5448 19.4034 10.7592 19.2319C10.9736 19.055 11.0809 18.8031 11.0809 18.4761C11.0809 18.1545 10.971 17.9106 10.7512 17.7444C10.5368 17.5782 10.2205 17.4952 9.80242 17.4952H8.93406V16.8761H9.74614C10.0999 16.8761 10.384 16.7849 10.5984 16.6027C10.8128 16.4204 10.92 16.1712 10.92 15.8549C10.92 15.5655 10.8209 15.3457 10.6225 15.1956C10.4296 15.0402 10.1535 14.9624 9.79438 14.9624C9.18867 14.9624 8.66337 15.1742 8.21846 15.5976L7.95313 15.0268C8.17826 14.8016 8.45699 14.6274 8.78933 14.5041C9.12167 14.3808 9.47277 14.3192 9.84263 14.3192C10.4055 14.3192 10.8477 14.4478 11.1693 14.7051C11.4909 14.9624 11.6517 15.3216 11.6517 15.7826C11.6517 16.131 11.5526 16.4311 11.3542 16.6831C11.1613 16.9297 10.8959 17.0931 10.5582 17.1735V17.0851C10.9549 17.1548 11.2631 17.3183 11.4829 17.5756C11.7026 17.8275 11.8125 18.1438 11.8125 18.5243C11.8125 19.0228 11.6356 19.4168 11.2819 19.7063C10.9334 19.9904 10.4537 20.1324 9.84263 20.1324Z"
                      fill="black"
                    />
                  </svg>
                  <span>{item?.tier}</span>
                </div>
                <div style={styles.body}>
                  <div
                    style={
                      limits?.tier === item?.tier
                        ? styles.bodycard2
                        : styles.bodycard
                    }
                  >
                    <span>Daily Transaction Limit</span>
                    <b>₦ {kFormatter(item?.daily_limit)}</b>
                  </div>
                  <div
                    style={
                      limits?.tier === item?.tier
                        ? styles.bodycard2
                        : styles.bodycard
                    }
                  >
                    <span>Limit Per Transfer</span>
                    <b>₦ {kFormatter(item?.transfer_limit)}</b>
                  </div>
                </div>
              </div>
            );
          })}
        </Box>
      )}
      <div
        style={{
          display: "grid",
          placeItems: "center",
        }}
      >
        {accountTierList?.[1]?.tier !== limits?.tier && (
          <Button
            variant="contained"
            type="button"
            color="green3"
            sx={styles.btn}
            onClick={() => {
              navigate(`/upgrade-tier?tierId=${accountTierList[1]?.id}`);
            }}
          >
            Upgrade Tier
          </Button>
        )}
      </div>
    </Box>
  );
};

export default AccountTier;
